import { Sparkle } from "lucide-react";

const ITEMS = [
  "Let AI Read the World to You",
  "Read Without Limits",
  "Accessibility First",
  "Built for Independence",
  "AI Explain Mode",
  "Your Eyes, Amplified",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section aria-label="VoiceLens AI values" className="border-y border-[#00D4FF]/12 bg-[#050F1F]/60 py-6">
      <div className="overflow-hidden">
        <div className="animate-marquee flex w-max items-center gap-10 pr-10">
          {row.map((item, i) => (
            <span key={i} className="flex items-center gap-10" aria-hidden={i >= ITEMS.length}>
              <span className="font-display whitespace-nowrap text-lg font-semibold tracking-wide text-slate-300 sm:text-xl">
                {item}
              </span>
              <Sparkle className="h-4 w-4 shrink-0 fill-[#00D4FF]/40 text-[#00D4FF]" aria-hidden="true" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
